/* Tag "The Green Scene" toggle cards
   Ghost's toggle card renders no identifying class, so the Green Scene boxes are
   matched on their heading text and tagged for the branded panel styling in
   screen.css. Keep the label below in sync with the .glg-green-scene rules there. */
(function () {
    const label = 'the green scene';
    const cards = document.querySelectorAll('.kg-toggle-card');

    cards.forEach(function (card) {
        const heading = card.querySelector('.kg-toggle-heading-text');
        if (!heading) return;

        if (heading.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === label) {
            card.classList.add('glg-green-scene');
        }
    });
})();
